import {
	DEFAULT_MEDIA_QUERY_PLATFORMS as MQ,
	COMPONENT_STATES as STATE,
	COMPONENT_TYPE as TYPE,
	CONTENT_ALIGN_Y,
} from 'common/constants';
import { generateElementId, generateNodeId } from 'utils/generate-id';
import View from 'client/components/common/BuildingBlocks/Card/Card';

export const CARD = () => {
	const _id = generateElementId();

	return {
		view: View,
		model: {
			_id,
			type: TYPE.CARD,
			uiConfig: {
				layer: undefined,
				editorProps: {
					name: CARD.displayName,
					selectable: true,
					draggable: false,
					expandable: false,
					expanded: false,
				},
				nodeProps: {
					id: generateNodeId(_id, CARD.displayName),
				},
				componentProps: {
					other: {
						[STATE.DEFAULT]: {
							[MQ.DEFAULT]: {
								contentAlignY: CONTENT_ALIGN_Y.top,
								muted: true,
							},
						},
					},
					styles: {
						[STATE.DEFAULT]: {
							[MQ.DEFAULT]: {},
							[MQ.DESKTOP]: {},
							[MQ.TABLET]: {},
							[MQ.MOBILE]: {},
						},
					},
				},
			},
			children: [],
		},
	};
};

CARD.displayName = 'Card';
